module.exports = __webpack_public_path__ + "img/icon_pre-registration_management_hover.b62d1bab.svg";